// extracted by mini-css-extract-plugin
module.exports = {"icon":"UserTagsContainer-icon-zXgmf","tag":"UserTagsContainer-tag-n4Pb1"};